/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Footer_TaglineInputs */

const en_gc_footer_tagline = /** @type {(inputs: Gc_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clarity, cell by cell.`)
};

const zh_gc_footer_tagline = /** @type {(inputs: Gc_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让数据更清晰。`)
};

/**
* | output |
* | --- |
* | "Clarity, cell by cell." |
*
* @param {Gc_Footer_TaglineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_footer_tagline = /** @type {((inputs?: Gc_Footer_TaglineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Footer_TaglineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_footer_tagline(inputs)
	return zh_gc_footer_tagline(inputs)
});
export { gc_footer_tagline as "gc.footer.tagline" }